export default "__VITE_ASSET__e6b1551b__"